import { render } from "./trumpetFTConsumptionDetails.vue?vue&type=template&id=b1f45504&scoped=true"
import script from "./trumpetFTConsumptionDetails.vue?vue&type=script&lang=js"
export * from "./trumpetFTConsumptionDetails.vue?vue&type=script&lang=js"

import "./trumpetFTConsumptionDetails.vue?vue&type=style&index=0&id=b1f45504&scoped=true&lang=css"
import "./trumpetFTConsumptionDetails.vue?vue&type=style&index=1&id=b1f45504&lang=css"
script.render = render
script.__scopeId = "data-v-b1f45504"

export default script